import moment from 'moment';

export default (start, end) => {
  const a = moment(start, 'DD/MM/YYYY');
  const b = moment(end, 'DD/MM/YYYY');

  return b.diff(a, 'days');
};
